// html 处的 lang 值
export const LocalesLangDetail = {
    us: 'en-US',
    uk: 'en-GB',
    ca: 'en-CA',
    au: 'en-AU',
    eu: 'en-GB',
    jp: 'ja-JP',
    kr: 'ko-KR',
    de: 'de-DE',
    fr: 'fr-FR',
    cn: 'zh-CN',
    it: 'it-IT',
    es: 'es-ES',
    za: 'en-ZA', //'af-ZA',
    sa: 'ar', //'ar-SA',
    tw: 'zh-Hant-TW',
    br: 'pt-BR',
    cis: 'ru-RU',
};
